
























import {Vue, Component, Prop, PropSync} from 'vue-property-decorator';
import LayerPopup from '@/components/LayerPopup.vue';
import {PopupRequestData} from '@/types';
import {makeFastFuncOfGetI18n} from '@/utils/i18n';

export interface CloseInfoPopupData {
  closeReason: string;
  closeReasonDetail: string;
}

@Component({
  components: {
    LayerPopup,
  }
})
export default class RecurringPaymentCloseInfoLayerPopup extends Vue {
  private getI18nOfThis = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_ORDER');

  @PropSync('visible')
  private visibleSync: boolean;
  @Prop({ required: true })
  private data!: CloseInfoPopupData;

  private popupRequestData: PopupRequestData = {
    id: 'recurringPaymentCloseInfoPopup',
    hasConfirmBtn: false,
    title: '해지 상세정보',
  }
}


